var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#DFDDE3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security Gurad At Main Entry Gate"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 806,
    transform: "translate(-1072 -217)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 96"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1007,
    y: -144,
    width: 1358,
    height: 717,
    rx: 6,
    fill: "#F9F9F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 186"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -994,
    y: -76,
    width: 1332,
    height: 594,
    rx: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 188"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -764,
    y: -66,
    width: 1092,
    height: 574,
    rx: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -66,
    width: 348,
    height: 594,
    rx: 5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component 36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 18.3332C5.39764 18.3332 1.66669 14.6022 1.66669 9.99984C1.66669 5.39746 5.39764 1.6665 10 1.6665C14.6024 1.6665 18.3334 5.39746 18.3334 9.99984C18.3334 14.6022 14.6024 18.3332 10 18.3332ZM9.16885 13.3332L15.0614 7.44061L13.8829 6.2621L9.16885 10.9762L6.81186 8.61909L5.63334 9.79767L9.16885 13.3332Z",
    fill: "#4DB748"
  })))))), /*#__PURE__*/React.createElement("rect", {
    x: -764.5,
    y: -66.5,
    width: 1093,
    height: 575,
    rx: 10.5,
    stroke: "#FFDD6B"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -994,
    y: -76,
    width: 1332,
    height: 594,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -764,
    y: -66,
    width: 1092,
    height: 574,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCheckIcon);
export default __webpack_public_path__ + "static/media/RoundCheckIcon.8e616e748be9ea917fcb98d4f2bbfb1e.svg";
export { ForwardRef as ReactComponent };